import config from 'config';
import { configureStore } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducer from 'reducers';
import { IS_SNAP } from 'variables/main';

const {
  application: { environment }
} = config;

const createStore = () => {
  // process.env.NODE_ENV is inlined at build time (CRA via DefinePlugin, Vite
  // via `define` in vite.config.js), so the dev-only redux-logger branch
  // dead-codes in production. The top-level static import is required for
  // Vite — it does not support `require()` in ESM files; tree-shaking removes
  // unused exports in the production build.
  const isDev = process.env.NODE_ENV !== 'production';

  const middlewares = [thunk];

  if (isDev && environment !== 'prod' && !IS_SNAP) {
    middlewares.push(createLogger({ collapsed: true }));
  }

  return configureStore({
    reducer,
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers(),
    middleware: () => middlewares.filter(Boolean),
    devTools: isDev
  });
};

export default createStore;
